<template>
    <div id="appLayout">
            <app-drawer class="app--drawer"></app-drawer>
            <app-toolbar class="app--toolbar"></app-toolbar>
            <v-content>
            <!-- Page Header -->
            <!-- <page-header v-if="$route.meta.breadcrumb"></page-header> -->
            <div class="page-wrapper">
                <router-view></router-view>
            </div>
            <!-- App Footer -->
            <!-- <v-footer height="auto" class="white pa-3 app--footer">
                <span class="caption">isocked.com Design &copy; {{ new Date().getFullYear() }}</span>
                <v-spacer></v-spacer>
                <span class="caption mr-1"> Make With Love </span> <v-icon color="pink" small>favorite</v-icon>
            </v-footer> -->
        </v-content>
    </div>
</template>

<script>
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import PageHeader from '@/components/PageHeader';

export default {
  name: 'MainTheme',
  metaInfo: {
    title: 'App',
  },
  components: {
    AppDrawer,
    AppToolbar,
    PageHeader
  },
}
</script>